module.exports = __webpack_public_path__ + "static/media/icon_close_store.0fe3496a.svg";